import type { TOC } from '@ember/component/template-only';

import styles from './trophy-modal-layout.module.css';

interface GeneralRoiTrophiesContentTrophyModalLayoutSignature {
  Args: {};
  Blocks: {
    animation: [];
    content: [];
  };
}

const GeneralRoiTrophiesContentTrophyModalLayout = <template>
  <div
    class="px-600 pt-400
      {{styles.text-content}}
      flex flex-col items-center gap-400 text-center"
  >
    {{yield to="content"}}
  </div>
  <div class="{{styles.animation-wrapper}} relative w-full overflow-hidden">
    {{yield to="animation"}}
  </div>
</template> satisfies TOC<GeneralRoiTrophiesContentTrophyModalLayoutSignature>;

export default GeneralRoiTrophiesContentTrophyModalLayout;
